import React from 'react';
import Modal from '../../../BaseComponents/Modal';
import Button from '../../../BaseComponents/Button';
import { ConditionWithDetails, getFbsConditionLabel } from '../../../../api/conditions';
import './ConditionModal.scss';
import trash from "../../../../assets/icons/TrashBin2.svg";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  condition: ConditionWithDetails | null;
  onEdit?: (condition: ConditionWithDetails) => void;
  onDelete?: (conditionId: number) => void;
};

const ViewConditionModal: React.FC<Props> = ({ isOpen, onClose, condition, onEdit, onDelete }) => {
  if (!condition) return null;

  const handleEdit = () => {
    if (onEdit) {
      onEdit(condition);
      onClose(); // Close the view modal
    }
  };

  const handleDelete = () => {
    if (onDelete) {
      onDelete(condition.id);
    }
  };

  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose} 
      title="Medical Condition"
      width="800px"
    >
      <div className="condition-view-modal">
        <div className="condition-details">
          <div className="detail-field">
            <label className="field-label">Name of the condition</label>
            <div className="field-value">{condition.name}</div>
          </div>

          <div className="detail-field">
            <label className="field-label">Body system(s)</label>
            <div className="field-value">
              {condition.body_systems && condition.body_systems.length > 0 
                ? condition.body_systems.map(bs => bs.title).join(', ')
                : 'No body systems assigned'
              }
            </div>
          </div>

          <div className="detail-field">
            <label className="field-label">Description</label>
            <div className="field-value">
              {condition.description || 'No description provided'}
            </div>
          </div>

          <div className="detail-field">
            <label className="field-label">Associated biomarkers</label>
            <div className="field-value">
              {condition.biomarkers && condition.biomarkers.length > 0 
                ? condition.biomarkers.map(bm => bm.name).join(', ')
                : 'No biomarkers associated'
              }
            </div>
          </div>

          <div className="detail-field">
            <label className="field-label">Associated FBS conditions</label>
            <div className="field-value">
              {condition.mri_conditions && condition.mri_conditions.length > 0
                ? condition.mri_conditions.map(mc => getFbsConditionLabel(mc)).join(', ')
                : 'No FBS conditions associated'
              }
            </div>
          </div>
        </div>

        <div className="modal-actions">
          <Button
            text="Edit"
            onClick={handleEdit}
            isSecondary={false}
          />
          <button 
            className="delete-button"
            onClick={handleDelete}
          >
            <img src={trash} alt="delete" />
            Delete Medical condition
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ViewConditionModal;
